var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 gap-4"},[_c('line-chart',{staticClass:"col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4",attrs:{"chart-data":_vm.reportsPerMonth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }